import { render } from "./ProjectShareMemberInvitation.vue?vue&type=template&id=fa9ceed4&ts=true"
import script from "./ProjectShareMemberInvitation.vue?vue&type=script&lang=ts"
export * from "./ProjectShareMemberInvitation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__